@if (show && ((announcements$ | async)?.length ?? 0) > 0) {
  <div id="announcements-wrapper">
    <section class="announcements-banner" fxFlex fxLayout="row" fxLayoutAlign="start start">
      <div fxFlex>
        @for (announcement of (announcements$ | async) ?? []; track announcement.id) {
          <div class="ag-pa-sm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <div><mat-icon>info</mat-icon></div>
              <div fxLayout="column" fxFlex>
                <div class="mat-body-2">{{ announcement.title }}</div>
                <div class="mat-body">
                  {{ announcement.content }}
                </div>
                @if (announcement.hyperlinkUrl) {
                  <a [href]="announcement.hyperlinkUrl | normalizeUrl" target="_blank">
                    {{ announcement.hyperlinkText || announcement.hyperlinkUrl }}
                  </a>
                }
              </div>
            </div>
          </div>
          @if (!$last) {
            <mat-divider></mat-divider>
          }
        }
      </div>
    </section>
  </div>
}
